import "./set-public-path";
import initAuth, { LOGIN_ERROR_MESSAGE } from "./auth";
import {
  page,
  track,
  analytics,
  group,
  identify,
  initSegment,
} from "./telemetry";

const adapter = initAuth();
export const auth = {
  LOGIN_ERROR_MESSAGE,
  getUser: () => adapter.getUser(),
  isLoggedIn: () => adapter.isLoggedIn(),
  login: () => adapter.login(),
  getToken: async () => await adapter.acquireToken(),
  logout: () => adapter.logout(),
};

export const telemetry = {
  page,
  track,
  analytics,
  group,
  identify,
  initSegment,
};
